import React, { Dispatch, SetStateAction } from "react";
import { StyledModal } from "./styles";

import close from "../../assets/imgs/close.png"

interface iModal {
    children: React.ReactNode,
    showModal: Dispatch<SetStateAction<boolean>>,
    closeButton?: boolean
}

export const Modal = ({ showModal, children, closeButton }: iModal) => {
    return <StyledModal>
        <div className="modal">
            <div className="modal-header">
                {
                    !closeButton &&
                    <div className="close" onClick={() => showModal(false)}><img src={close} alt="Fechar" /></div>
                }
            </div>
            {children}
        </div>
    </StyledModal>;
};